// extracted by mini-css-extract-plugin
module.exports = {"title":"Bench_title__FmKGu","titleContainer":"Bench_titleContainer__BSJmE","animation":"Bench_animation__2kWBY","moveDown":"Bench_moveDown__1q6G7"};